import React, { useState, useEffect } from "react";
import {
    Grid,
    TextField,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Box,
    Typography, IconButton, MenuItem, Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Icon,
    Tooltip
} from "@mui/material";
import Loader from "../../components/Loader";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { useTranslation, withTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import CommonPagination from "../../components/CommonPagination";
import { useNavigate } from "react-router-dom";
import { countryActionID, DeleteActionUrl, GetClientListSearchUrl } from "../../utils/constants";
import { axiosDelete, axiosGet, axiosPost } from "../../utils/Axios";
import { useFillList } from "../../components/fillList";
import { useToast } from '../../components/toast';
import { Search, List, GridView, StarOutline, Star, Share, Delete, Edit, Close, Save, Cancel } from "@mui/icons-material";
import { HeaderBlock } from "@colliers/colliers-b2c";

const ClientUserList = () => {
    const { ToastComponent, showToast } = useToast();
    const navigate = useNavigate()
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleteModal, setDeleteModal] = useState(false);
    const [userID, setUserID] = useState('');
    const [userList, setUserList] = useState([]);
    const [userName, setUserName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [Status, setStatus] = useState('Active');
    const [reset, setReset] = useState(false);

    //pagination
    const [currentPage, setCurrentPage] = useState(1);
    const listItemsPerPage = 10;
    const startIndex = (currentPage - 1) * listItemsPerPage;
    const paginatedUserList = userList?.slice(startIndex, startIndex + listItemsPerPage);

    //translation
    //common
    const TAction = t("common.Action");
    const TnoRecordFound = t("common.noRecordFound");
    const Tsearch = t("common.search");
    const Treset = t("common.reset");
    const Tcancel = t("common.Cancel");
    const Tdelete = t("common.Delete");
    const Tstatus = t("common.status");
    const Tselect = t("common.select");
    const Tactive = t("common.active");
    const Tinactive = t("common.inactive");
    //list
    const TpageTitle = t("clientPage.pageTitle")
    const Temail = t("clientPage.Email")
    const TUser = t("clientPage.User")
    const TactiveDashboard = t("clientPage.activeDashboard")
    const TenterEmail = t("clientPage.addEmail")
    const TselectStatus = t("clientPage.selectStatus")
    const TcreatedBy = t("common.createdBy")
    const TcreatedDate = t("common.createdDate")
    const Tcountry = t("common.country")

    useEffect(() => {
        const userInfo = localStorage.getItem("userInfo");
        if (!userInfo) {
            navigate("/login/root-data");
            return;
        } else {
            const extractAccess = JSON.parse(localStorage.getItem('matchedModule'))
            const readAccess = extractAccess.read
            if (!readAccess) {
                navigate('/access-denied')
                return
            }
            getClientSearchList();
        }
        setIsLoading(true);
    }, [reset]);

    let statusValue;
    if (Status === "Active") {
        statusValue = true;
    } else if (Status === "" || Status === "0") {
        statusValue = null;
    } else {
        statusValue = false;
    }


    const getClientSearchList = async () => {
        const payload = {
            Name: userName != '' ? userName : '',
            EmailAddress: emailAddress != '' ? emailAddress : '',
            Status: statusValue
        }
        try {
            setIsLoading(true);
            const response = await axiosPost(GetClientListSearchUrl, payload);
            console.log(response);
            if (response) {
                console.log(response)
                setUserList(response);
                setCurrentPage(1)
            } else {
                console.error("Failed to fetch dashboards: No data found.");
            }
        } catch (error) {
            console.error("Error fetching dashboards:", error);
        } finally {
            setIsLoading(false);
        }
    }
    const handleFilterChange = (e, field) => {
        const value = e.target.value
        if (field == 'user') {
            setUserName(value)
        } else if (field == 'email') {
            setEmailAddress(value)
        } else if (field == 'status') {
            setStatus(value)
        }
    };
    const resetSearch = async () => {
        setUserName("");
        setEmailAddress("");
        setStatus('Active');
        setReset(true)
        setCurrentPage(1)
    };
    const toggleDeleteModal = (userID) => {
        if (isDeleteModal) {
            setDeleteModal(false);
            setUserID('');
        } else {
            setDeleteModal(true);
            setUserID(userID);
        }
    };
    const handleDelete = async (userID) => {
        try {
            setIsLoading(true);
            const response = await axiosDelete(DeleteActionUrl, { moduleID: 2, valueID: userID.toString() });
            if (response) {
                showToast('success', 'Successfully Deleted!');
                getClientSearchList();
            } else {
                showToast('error', 'Failed to fetch user list: No data found.');
            }
        } catch (error) {
            console.log(error)
            showToast('error', `Error fetching user list:, ${error}`)
        } finally {
            setIsLoading(false);
            setDeleteModal(false); // Close the modal after the action
        }
    }
    const navigateEdit = (userID) => {
        console.log(userID, 'list')
        navigate('/client-user-management-manage', { state: { userID } })
    }
    return (
        <>
            {isLoading ? <Loader /> : <></>}
            <HeaderBlock left="" title={TpageTitle} leftCenterAlign="true" actionsCenterAlign="true" />

            <Box
                id="main" className="full-width padding-right-m padding-left-m padding-bottom-m padding-top-none clientListMainBox">
                <Box className="pagetitle main-area-top"
                    textAlign="center">
                    <section className="section page-body">
                        <Box className="" >
                            <Box className="margin-top-base margin-bottom-none"
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 2,
                                    alignItems: "flex-start",
                                }}
                            >

                                <TextField className="padding-top-s list-page-control-client margin-bottom-s"
                                    label={Temail}
                                    variant="outlined"
                                    placeholder={TenterEmail}
                                    value={emailAddress}
                                    onChange={(e) => handleFilterChange(e, "email")}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />

                                <TextField className="padding-top-s list-page-control-client margin-bottom-s text-align-left"
                                    label={Tstatus}
                                    variant="outlined"
                                    select
                                    placeholder={TselectStatus}
                                    value={Status}
                                    onChange={(e) => handleFilterChange(e, "status")}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    <MenuItem value="">{Tselect}</MenuItem>
                                    <MenuItem value="Active">{Tactive}</MenuItem>
                                    <MenuItem value="In-Active">{Tinactive}</MenuItem>
                                </TextField>

                                <Button variant="contained" className="margin-right-s margin-left-s margin-top-s" onClick={getClientSearchList}>
                                    {Tsearch}
                                </Button>
                                <Button className="margin-top-s" variant="contained" onClick={resetSearch}>
                                    {Treset}
                                </Button>
                                <TableContainer className="border list-height">
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>{TUser}</TableCell>
                                                <TableCell>{TcreatedBy}</TableCell>
                                                <TableCell>{TcreatedDate}</TableCell>
                                                <TableCell>{Tcountry}</TableCell>
                                                <TableCell align="center">{TactiveDashboard}</TableCell>
                                                <TableCell>{Tstatus}</TableCell>
                                                <TableCell align="center">{TAction}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {paginatedUserList?.length > 0 ? (
                                                paginatedUserList.map((item, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{item.emailAddress}</TableCell>
                                                        <TableCell>{item.createdBy}</TableCell>
                                                        <TableCell>{item.createdDate}</TableCell>
                                                        <TableCell>{item.country}</TableCell>
                                                        <TableCell align="center">{item.activeDashboard}</TableCell>
                                                        <TableCell>{item.status}</TableCell>
                                                        <TableCell align="center">
                                                            {/* <IconButton
                                      color="error"
                                      onClick={() => toggleDeleteModal(item.userID)}
                                    >
                                      <DeleteIcon />
                                    </IconButton>

                                    <IconButton
                                      color="primary"
                                      onClick={() => navigateEdit(item.userID)}
                                    >
                                      <Edit />
                                    </IconButton> */}



                                                            <Button className="padding-right-none">
                                                                <Tooltip title="Remove">
                                                                    <Icon className='fa-light fa-trash-can font-size-base text-primary' onClick={() => toggleDeleteModal(item.userID)} />
                                                                </Tooltip>
                                                            </Button>

                                                            <Button className="padding-right-none">
                                                                <Tooltip title="Edit">
                                                                    <Icon className='fa-light fa-pen-to-square font-size-base text-primary' onClick={() => navigateEdit(item.userID)} />
                                                                </Tooltip>
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={7}>{TnoRecordFound}</TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Dialog className="border-radius-soft padding-y-base padding-x-base text-align-center clientListDialog"
                                    open={isDeleteModal}>
                                    <DialogTitle>
                                        <Typography className="text-primary text-align-left" variant="h6">
                                            {t("common.deleteMessage")}
                                        </Typography>
                                    </DialogTitle>
                                    <DialogContent>
                                        <Typography className="margin-bottom-base text-primary font-size-h5 text-align-left">
                                            {t("user_mgmt.deleteUser")}
                                        </Typography>
                                    </DialogContent>
                                    <DialogActions className="dialogAction">
                                        <Button
                                            variant="outlined"
                                            startIcon={<Cancel />}
                                            onClick={() => toggleDeleteModal("")}
                                            className="clientListDialogActionBtn">
                                            {Tcancel}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleDelete(userID)}
                                            startIcon={<Delete />}
                                            className="clientListDialogActionBtn1">
                                            {Tdelete}
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </Box>
                        </Box>
                    </section>
                </Box>
            </Box>
            {ToastComponent}
        </>
        //  )}
        //</>
    );

};

export default withTranslation()(ClientUserList);
